export default __webpack_public_path__ + "static/media/chat_logo.95f11b14.svg";